import { useMutation, useQueryClient } from "@tanstack/react-query";
import { orbitLOnboardingDetailKeys } from "Api/Queries/Merchants/useOrbitLOnboardingDetailQuery";
import { orbitLOnboardingListKeys } from "Api/Queries/Merchants/useOrbitLOnboardingListQuery";
import { putMerchantsOrbitLTerminalCountChangeRequestRequestGroupID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  requestGroupID: string;
  isDismissed: boolean;
  note?: string;
};

type Props = {
  onSuccess?: (parameters: Parameters) => void;
  onError?: () => void;
};

export const useResolveTerminalCountChangeRequestMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ requestGroupID, isDismissed, note }: Parameters) =>
        putMerchantsOrbitLTerminalCountChangeRequestRequestGroupID(
          { isDismissed, note },
          requestGroupID,
        ),
    ),
    onSuccess: (_data, parameters: Parameters) => {
      queryClient.invalidateQueries({
        queryKey: orbitLOnboardingDetailKeys.byMerchantPublicId(
          parameters.merchantPublicID,
        ),
      });
      // The queue badge and the request column both come off the list.
      queryClient.invalidateQueries({ queryKey: orbitLOnboardingListKeys.all });
      onSuccess?.(parameters);
    },
    onError,
  });
};
